function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from "react";
let Tooltip = class Tooltip extends Component {
    componentDidMount() {
        if (!Tooltip.Tippy) import("./Tippy").then((module)=>{
            Tooltip.Tippy = module.default;
            this.forceUpdate();
        }).catch((error)=>{
            console.error(error);
        });
    }
    render() {
        const _props = this.props, { children  } = _props, rest = _objectWithoutProperties(_props, [
            "children"
        ]);
        const As = Tooltip.Tippy;
        if (!As) return children;
        return /*#__PURE__*/ _jsx(As, _objectSpread({
            placement: "bottom",
            arrow: true,
            duration: 0,
            delay: [
                500,
                0
            ],
            animation: undefined,
            appendTo: document.body,
            touch: false
        }, rest, {
            children: children
        }));
    }
};
export default Tooltip;
